import * as ApplicationConfigurationService from '../config/ApplicationConfigurationService.client';
import { APIConfigurationServiceDomain } from '../config/domain/APIConfigurationService/domain';
import { FetchClient } from './FetchClient/FetchClient.client';
import { RESTServiceClient } from './RESTServiceClient';

export { FetchServiceDomain as Domain } from './domain';

class RESTServiceClientManager
    implements Record<keyof APIConfigurationServiceDomain.SupportedServices, RESTServiceClient>
{
    readonly #graphqlService: RESTServiceClient;
    readonly #maxService: RESTServiceClient;
    readonly #settingsService: RESTServiceClient;
    readonly #zillowAuthService: RESTServiceClient;
    readonly #zillowAuth0Service: RESTServiceClient;
    readonly #zillowDomainService: RESTServiceClient;

    public constructor(services: APIConfigurationServiceDomain.SupportedServices) {
        const fetchClient = FetchClient.getInstance();
        this.#graphqlService = new RESTServiceClient(services.graphql, fetchClient);
        this.#maxService = new RESTServiceClient(services.max, fetchClient);
        this.#settingsService = new RESTServiceClient(services.settings, fetchClient);
        this.#zillowAuthService = new RESTServiceClient(services.zillowAuth, fetchClient);
        this.#zillowAuth0Service = new RESTServiceClient(services.zillowAuth0, fetchClient);
        this.#zillowDomainService = new RESTServiceClient(services.zillowDomain, fetchClient);
    }

    get graphql() {
        return this.#graphqlService;
    }

    get max() {
        return this.#maxService;
    }

    get settings() {
        return this.#settingsService;
    }

    get zillowAuth() {
        return this.#zillowAuthService;
    }

    get zillowAuth0() {
        return this.#zillowAuth0Service;
    }

    get zillowDomain() {
        return this.#zillowDomainService;
    }
}

export { FetchClient };

export class RESTServiceClientManagerFactory {
    static #client: RESTServiceClientManager | null = null;

    static getServiceClientManager(): RESTServiceClientManager {
        if (!RESTServiceClientManagerFactory.#client) {
            RESTServiceClientManagerFactory.#client = new RESTServiceClientManager(
                ApplicationConfigurationService.ConfigProvider.getInstance().apiConfig.services
            );
        }
        return RESTServiceClientManagerFactory.#client;
    }
}
